const settings = {
  navHeight: '48px',
  drawerWidth: 200,
  drawerCollapsedWidth: 48,
  dateFormat: 'YYYY-MM-DD',
};
export default settings;
